module.exports = __webpack_public_path__ + "img/1.b72fb66e.svg";